import { render, staticRenderFns } from "./GuWeiPolicy.vue?vue&type=template&id=e80fd69a&scoped=true"
import script from "./GuWeiPolicy.vue?vue&type=script&lang=js"
export * from "./GuWeiPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80fd69a",
  null
  
)

export default component.exports